import * as types from "./actionTypes";
import * as postedScheduleApi from '../../api/postedScheduleApi';

/**
 * Dispatches an updated resource when the user selects a different resource.
 * @param {*} myQuickSchedulesArray 
 */
export function updateMyQuickSchedulesArray(myQuickSchedulesArray) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_MY_QUICK_SCHEDULES_ARRAY,
      myQuickSchedulesArray
    });
  };
}

/**
 * Returns a list of posted schedules for a resource from the api.
 * @param {*} resourceId
 */
export function fetchListMyQuickSchedules(resourceId) {
  return function(dispatch) {
    return postedScheduleApi
      .getListPostedSchedules(resourceId)
      .then(listMyQuickSchedules => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_LIST_MY_QUICK_SCHEDULES_SUCCESS,
          listMyQuickSchedules
        });
      })
      .catch(error => {
        throw error;
      });
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/myQuickScheduleActions.js